module.exports = __webpack_public_path__ + "img/anatomy-types.e335f317.svg";